// ProjectTabAdministration.jsx - Versão com fallback
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setDocumentModels } from "../../store/modules/model/actions";
import { blockchainService } from "../../services/blockchainService";
import DocumentModelTopics from "../projects_t_engineering/FileUpload/documentModel/DocumentModelTopics";

const ProjectTabAdministration = ({ user, project }) => {
  const dispatch = useDispatch();
  const documentModels = useSelector(state => state.documentModels.models);
  
  console.log('📦 DocumentModels no Redux:', documentModels);

  // ✅ Se não tiver modelos, tenta buscar
  useEffect(() => {
    const fetchModelsIfNeeded = async () => {
      if (!documentModels || documentModels.length === 0) {
        try {
          const token = sessionStorage.getItem("Authorization");
          const headers = { Authorization: token };
          const response = await blockchainService.getDocumentModels(headers);
          dispatch(setDocumentModels(response));
        } catch (error) {
          console.error('❌ Erro ao buscar modelos:', error);
        }
      }
    };

    fetchModelsIfNeeded();
  }, [dispatch, documentModels]);

  // Busca o modelo de documento pelo nome
  const modeloAdm = documentModels?.find(model => model.nome === 'Modelo Administrativo');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!documentModels || documentModels.length === 0) {
    return <div>⏳ Carregando modelos de documentos...</div>;
  }

  if (!modeloAdm) {
    return (
      <div>
        <p>❌ Modelo Administrativo não encontrado.</p>
        <p>📋 Modelos disponíveis: {documentModels.map(m => m.nome).join(', ')}</p>
      </div>
    );
  }

  return (
    <div>
      <DocumentModelTopics
        projectId={project.id}
        modeloId={modeloAdm.id}
        telaName="Administrativo"
      />
    </div>
  );
};

export default ProjectTabAdministration;